const AuthSSOView = () =>
  import(/*webpackChunkName: "AuthSSOView"*/ "../../../views/AuthSSO.vue");

export default {
  path: "authsso/:token",
  name: "authsso",
  component: AuthSSOView,
  meta: { requiresAuth: false, requiresEntitlement: false },
};
